var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1109,
    height: 1024,
    viewBox: "0 0 1109 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M645.939 203.501C707.963 137.246 735.838 74.9088 713.598 35.2391C673.158 -36.8942 482.328 -6.76371 287.369 102.537C92.4089 211.839 -32.8538 358.92 7.58663 431.053C30.7004 472.281 102.942 480.103 197.003 458.829C68.5229 599.975 19.7139 765.574 87.651 886.736C185.089 1060.51 485.783 1077.07 759.269 923.724C1032.75 770.376 1175.47 505.191 1078.03 331.415C1008.89 208.11 837.416 163.961 645.939 203.501Z",
    fill: "#ECEAE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestBg);
export default __webpack_public_path__ + "static/media/guest_bg.05077ee969a075eb5005ea3a199e1d89.svg";
export { ForwardRef as ReactComponent };